import Reveal from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1559185590-879c66a55254?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxzcGElMjBhZXN0aGV0aWNpYW4lMjBuZXV0cmFsfGVufDB8fHx8MTc3ODI4NzYyMnww&ixlib=rb-4.1.0&q=85";

const principles = [
  {
    n: "01",
    t: "Personalized, always",
    d: "Every treatment is built for you in the room — your skin, your body, what the day asked of you.",
  },
  {
    n: "02",
    t: "Slow & intentional",
    d: "We don&rsquo;t rush. The work happens in the breath, the pace, and the quiet.",
  },
  {
    n: "03",
    t: "Honest skincare",
    d: "Education first. No upsells — just thoughtful guidance you can actually use at home.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-36 bg-[#FAF6E8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-16">
        <div className="col-span-12 lg:col-span-5 lg:sticky lg:top-32 self-start">
          <Reveal className="overline mb-6">About Bella</Reveal>
          <Reveal delay={1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light bb-ink">
              A space made to <span className="italic text-[#C9A65A]">soften</span>{" "}
              the day.
            </h2>
          </Reveal>
          <Reveal delay={2} className="mt-8 space-y-5 max-w-md text-base sm:text-lg bb-ink-soft font-light leading-relaxed">
            <p>
              Bella created Beauty &amp; Balance to help people reconnect with
              their bodies, slow down, and take care of themselves in a way
              that feels supportive and intentional.
            </p>
            <p>
              Whether you&rsquo;re here for massage to release tension, or a
              facial to care for your skin, the goal is the same — to meet you
              where you are and gently help you move toward balance.
            </p>
          </Reveal>
          <Reveal delay={3} className="mt-10 inline-flex items-center gap-3 border-l border-[#0F1F4E] pl-4">
            <span className="font-serif text-xl italic bb-ink">Bella</span>
            <span className="overline">Owner &amp; lead esthetician</span>
          </Reveal>
        </div>

        <div className="col-span-12 lg:col-span-7">
          <Reveal className="relative">
            <img
              src={ABOUT_IMG}
              alt="Bella — licensed Sacramento esthetician at work in her downtown studio"
              data-testid="about-image"
              loading="lazy"
              className="w-full h-[420px] md:h-[560px] object-cover rounded-lg border border-[#D9CFA0]"
            />
          </Reveal>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            {principles.map((p, i) => (
              <Reveal
                key={p.n}
                delay={i + 1}
                testId={`principle-${i + 1}`}
                className="border-t border-[#0F1F4E] pt-5"
              >
                <div className="overline mb-4">{p.n}</div>
                <h3 className="font-serif text-2xl bb-ink mb-2">{p.t}</h3>
                <p
                  className="bb-ink-soft text-sm leading-relaxed font-light"
                  dangerouslySetInnerHTML={{ __html: p.d }}
                />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
